import { Injectable } from "@angular/core";
import { BaseHandler } from "@app/core/shared/data/network/base-handler";
import { ApiUrls } from "@app/core/shared/data/network/api-urls";
import { Observable, catchError, from, map, of } from "rxjs";
import {
  HandlerBuilder,
  HttpMethod,
} from "@app/core/shared/data/network/base-handler.parameters";
import { TokenAuthorization } from "@app/core/shared/data/network/token-authorization";
import { Share, ShareResult } from "@capacitor/share";

@Injectable({ providedIn: "root" })
export class ShareMessageCapacitor {
  execute(message: string, url: string): Observable<string> {
    return from(
      Share.share({
        text: message,
        url: url,
      })
    ).pipe(
      map((share: ShareResult) =>
        !!share.activityType ? share.activityType : ""
      ),
      catchError((err) => of("error not catched"))
    );
  }
}
